let hostname = ''

if (window.location.hostname === 'localhost') {
  hostname = 'http://localhost'
} else {
  hostname = window.location.origin
}

export default hostname
